import React, { useState, useRef, useEffect } from 'react'; 
import { useNavigate, useLocation } from "react-router-dom"; 
import { AiOutlineHome, AiFillHome } from "react-icons/ai";
import { RiAccountCircleLine } from "react-icons/ri"; 
import { MdOutlineDocumentScanner, MdDocumentScanner, MdOutlineStore, MdStore } from "react-icons/md";
import { FaMessage, FaRegMessage } from "react-icons/fa6";
import Photosicon from '../assets/photos_icon.png'; 
import Cookies from 'js-cookie';
import "./Navbar.css";
export default function Navbar() {
    const location = useLocation(); // Get current route
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [guid, setGuid] = useState("");
    const [photoURL, setPhotoURL] = useState("");
    const [isVisible, setIsVisible] = useState(false);
    const [userlogin, setuserlogin] = useState(false);
    useEffect(() => {
        const existingUser = Cookies.get("guid");
        if (existingUser != null) {
            setGuid(existingUser);
            setuserlogin(true);
            const photo = Cookies.get("login_photoURL");

            setPhotoURL(photo);
        } else {
            setuserlogin(false);
        }
    }, []);
  
 
    return (
         <nav className="navbar-body">
                           <div
                               onClick={() => navigate('/')}
                               className={`nav-menubutton-icon ${location.pathname === '/' ? 'active' : ''}`}
                               title="Home"
                           >
                               {location.pathname === '/' ? (
                                   <AiFillHome className="icon" />
                               ) : (
                                   <AiOutlineHome className="icon" />
                               )}
       
                               <span className="button-text">Home</span>
                           </div>
                           <div
                               onClick={() => navigate('/message')}
                               className={`nav-menubutton-icon menubutton-nav ${location.pathname === '/message' ? 'active' : ''}`}
                               title="Message"
                           >
       
                               {location.pathname === '/message' ? (
                                   <FaMessage className="icon" />
                               ) : (
                                   <FaRegMessage className="icon" />
                               )}
                               <span className="button-text">Message</span>
                           </div>
                           <div
                               onClick={() => navigate('/history')}
                               className={`menubutton-nav nav-menubutton-icon  ${location.pathname === '/history' ? 'active' : ''}`}
                               title="History"
                           >
                               {location.pathname === '/history' ? (
                                   <MdDocumentScanner className="icon" />
                               ) : (
                                   <MdOutlineDocumentScanner className="icon" />
                               )}
                               <span className="button-text">History</span>
                           </div>
                           <div
                               onClick={() => navigate('/tools')}
                               className={`nav-menubutton-icon ${location.pathname === '/tools' ? 'active' : ''}`}
                               title="Tools"
                           >
       
                               {location.pathname === '/tools' ? (
                                   <MdStore className="icon" />
                               ) : (
                                   <MdOutlineStore className="icon" />
                               )}
                               <span className="button-text">Tools</span>
                           </div>
                       
         
        </nav>
    );
};